import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'app-mobile-numeric-input',
  templateUrl: './mobile-numeric-input.component.html',
  styleUrls: [
    './mobile-numeric-input.component.scss',
    '../odata-typeahead-search/odata-typeahead-search.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileNumericInputComponent implements OnChanges {
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;
  @Output() searchValueChanged: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('search') search!: ElementRef<HTMLInputElement>;

  public searchChanged(event: FocusEvent): void {
    this.searchValueChanged.emit((event.target as HTMLInputElement).value);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled) {
      this.search.nativeElement.value = '';
    }
  }
}
